module.exports = __webpack_public_path__ + "04_long_brown.77f851e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_long_brown.png
// module id = OpCm
// module chunks = 0